import { Grid, Typography } from '@mui/material';
import { Header } from 'src/components/header';
import { ViewOnlyAlert } from 'src/components/viewOnlyAlert';
import { PATHS } from 'src/constants/paths';
import { ILocation } from 'src/interfaces';
import { lang, useUserRole } from 'src/utils';

interface ITimeMachineHeaderProps {
  location: ILocation | undefined;
}

export const TimeMachineHeader = (props: ITimeMachineHeaderProps) => {
  const { location } = props;

  const { isViewOnly, isOwnerOperator } = useUserRole();

  return (
    <>
      <Grid container wrap="nowrap" justifyContent="space-between">
        <Header
          title={location?.hq?.name}
          breadcrumbItems={[
            {
              label: lang.locationGroup,
              link: !isOwnerOperator
                ? PATHS.LOCATION_GROUPS
                : PATHS.OO_LOCATION_PAGE,
            },
            {
              label: String(location?.hq?.name),
            },
          ]}
        />
        {isViewOnly && (
          <Grid item sx={{ ml: '62px', position: 'absolute', left: '89%' }}>
            <ViewOnlyAlert />
          </Grid>
        )}
      </Grid>

      <Grid item xs={4} md={1.5} marginY={1}>
        <Typography variant="subtitle2">{lang.nsn}</Typography>
        <Typography>{location?.hq?.store_number}</Typography>
      </Grid>

      <Grid item xs={4} md={1.5} marginY={1}>
        <Typography variant="subtitle2">{lang.storeAddress}</Typography>
        <Typography>
          {location?.hq?.address_line_1 ?? location?.hq?.address_line_2}
        </Typography>
      </Grid>

      <Grid item xs={4} md={1.5} marginY={1}>
        <Typography variant="subtitle2">{lang.locationTimeZone}</Typography>
        <Typography>{location?.hq?.timezone}</Typography>
      </Grid>
    </>
  );
};
